import PropTypes from 'prop-types';
import { Box, LinearProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';

export default function LoadingBar({ color = 'primary', overlay = false }) {
  const getBackgroundColor = (theme, colorProp) => {
    if (colorProp === 'inherit') {
      return alpha(theme.palette.text.primary, 0.12);
    }
    return alpha(theme.palette[colorProp].main, 0.12);
  };

  const getGradient = (theme, colorProp) => {
    if (colorProp === 'inherit') {
      return `linear-gradient(to right, ${alpha(theme.palette.text.primary, 0.5)}, ${theme.palette.text.primary})`;
    }
    return `linear-gradient(to right, ${alpha(theme.palette[colorProp].main, 0.5)}, ${theme.palette[colorProp].main})`;
  };

  if (overlay) {
    return (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.75),
          backdropFilter: 'blur(2px)',
          zIndex: 9999,
        }}
      >
        <Box sx={{ width: '50%', maxWidth: 300 }}>
          <LinearProgress 
            color={color}
            sx={{
              height: 6,
              borderRadius: 3,
              backgroundColor: (theme) => getBackgroundColor(theme, color),
              '& .MuiLinearProgress-bar': {
                borderRadius: 3,
                backgroundImage: (theme) => getGradient(theme, color),
                animation: 'moveIndeterminate 1.5s linear infinite',
                transformOrigin: '0% 50%',
                width: '50%',
              },
              '@keyframes moveIndeterminate': {
                '0%': {
                  transform: 'translateX(-100%) scaleX(1)',
                },
                '100%': {
                  transform: 'translateX(200%) scaleX(1)',
                },
              },
            }}
          />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress 
        color={color}
        sx={{
          height: 4,
          borderRadius: 2,
          backgroundColor: (theme) => getBackgroundColor(theme, color),
          '& .MuiLinearProgress-bar': {
            borderRadius: 2,
            backgroundImage: (theme) => getGradient(theme, color),
            animation: 'moveIndeterminate 1.5s linear infinite',
            transformOrigin: '0% 50%',
            width: '50%',
          },
          '@keyframes moveIndeterminate': {
            '0%': {
              transform: 'translateX(-100%) scaleX(1)',
            },
            '100%': {
              transform: 'translateX(200%) scaleX(1)',
            },
          },
        }}
      />
    </Box>
  );
}

LoadingBar.propTypes = {
  color: PropTypes.oneOf(['primary', 'secondary', 'error', 'info', 'success', 'warning', 'inherit']),
  overlay: PropTypes.bool,
};